import { Switch } from "react-aria-components";
import "./toggleSwitch.css";

interface PeriodSwitchProps {
	leftOption?: string;
	rightOption?: string;
	defaultSelected?:boolean;
	selected?: boolean;
	disabled?: boolean;
	handleChange: (isSelected?: boolean) => void;
}

export default function ToggleSwitch({ handleChange, leftOption, rightOption, defaultSelected=false , selected, disabled=false }: PeriodSwitchProps) {
	return (
		<div className="switchContainer">
			{leftOption}
			<Switch defaultSelected={defaultSelected} onChange={handleChange} isSelected={selected} isDisabled={disabled}>
				<div className="indicator" />
			</Switch>
			{rightOption}
		</div>
	);
}
